import $ from 'jquery';
import overlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars';

export default function initPopups () {
  const popupNode = document.querySelector('[data-remodal-id="popup"]');
  if (!popupNode) return;

  const $modal = $(popupNode);
  const api = $modal.remodal();
  const slot = popupNode.querySelector('.js-popup-content');
  if (!slot) return;

  function mountScroll () {
    slot.querySelectorAll('.js-scroll').forEach((host) => {
      const scroll = overlayScrollbars(host, { className: '_custom' });
      if (scroll) {
        scroll.scroll({ y: 0 });
        scroll.update(true);
      }
    });
  }

  function clearSlot () {
    slot.querySelectorAll('.js-scroll').forEach((host) => {
      const scroll = overlayScrollbars(host);
      if (scroll) scroll.destroy();
    });
    slot.innerHTML = '';
  }

  function openPopup (url, id) {
    const popupUrl = new URL(url, window.location.href);
    popupUrl.searchParams.set('ajax-popup', 'true');

    fetch(popupUrl)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        clearSlot();
        slot.innerHTML = html;
        mountScroll();
        if (id) history.replaceState(null, '', `#popup-${id}`);
        api.open();
      })
      .catch((err) => {
        console.error('Failed to fetch popup: ', err);
      });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-popup-open');
    if (!button) return;
    const href = button.getAttribute('data-href') || button.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    event.preventDefault();
    const id = button.getAttribute('data-popup-id') || href.split('/').pop().replace('.html', '');
    openPopup(href, id);
  });

  $modal.on('closed', () => {
    clearSlot();
    if (window.location.hash.startsWith('#popup-')) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  });

  const hash = window.location.hash;
  if (hash.startsWith('#popup-')) {
    const id = hash.slice('#popup-'.length);
    openPopup(`/popups/${id}.html`, id);
  }
}
